// Module
var code = "<div> <!--ko with: _displayView--> <!--ko template: {html: $data.GetTemplate.bind($data)}--><!--/ko--> <!--/ko--> </div>";
// Exports
export default code;